import { ErrorObjectArray } from 'api/v5/schemas';

/**
 * Simple util to parse a single error type from API error responses
 */
export const parseApiErrorType = (error: unknown) => {
  const v5Error = error as ErrorObjectArray;
  return v5Error?.errors?.[0]?.type;
};
